import api from './api';

export const userService = {
    updateLocation: async (userId, locationData) => {
        try {
            const response = await api.put(`/user/${userId}/update`, {
                location: locationData
            });
            return response.data;
        } catch (error) {
            console.error('Error updating location:', error);
            throw error;
        }
    },

    blockUser: async (userId, blockedUserId) => {
        try {
            const response = await api.post(`/user/${userId}/block`, {
                blockedUserId
            });
            return response.data;
        } catch (error) {
            console.error('Error blocking user:', error);
            throw error;
        }
    },

    unblockUser: async (userId, blockedUserId) => {
        try {
            const response = await api.delete(`/user/${userId}/block/${blockedUserId}`);
            return response.data;
        } catch (error) {
            console.error('Error unblocking user:', error);
            throw error;
        }
    },

    getBlockedUsers: async (userId) => {
        try {
            const response = await api.get(`/user/${userId}/blocked`);
            return response.data;
        } catch (error) {
            console.error('Error getting blocked users:', error);
            throw error;
        }
    },

    getUserByFbid: async (fbid) => {
        try {
            const response = await api.get(`/user/fbid/${fbid}`);
            return response.data && Object.keys(response.data).length > 0 ? response.data : null;
        } catch (error) {
            console.error('Error getting user by fbid:', error);
            if (error.response?.status === 404) {
                return null;
            }
            throw error;
        }
    },

    getUserByEmail: async (email) => {
        try {
            const response = await api.get(`/user/email/${email}`);
            return response.data && Object.keys(response.data).length > 0 ? response.data : null;
        } catch (error) {
            if (error.response?.status === 404) {
                return null;
            }
            throw error;
        }
    },

    createUser: async (userData) => {
        try {
            const response = await api.post('/user/newUser', userData);
            console.log('response', response);
            return response.data;
        } catch (error) {
            console.error('Error creating user:', error);
            throw error;
        }
    },

    // Retrouve un utilisateur existant (par fbid puis par email) après une connexion
    // via un provider externe (Google, Facebook...), sinon le crée.
    // Générique : réutilisable par n'importe quel écran/provider d'authentification.
    // firebaseUser : l'objet `user` renvoyé par Firebase Auth (result.user)
    // options.provider : identifiant du provider (ex. 'google.com')
    // options.ref / fbp / fbc / utm_* : données de tracking optionnelles (uniquement utiles à la création)
    resolveSocialUser: async (firebaseUser, { provider, ref = null, fbp, fbc, ...attribution } = {}) => {
        let existingUser = await userService.getUserByFbid(firebaseUser.uid);

        if (!existingUser && firebaseUser.email) {
            existingUser = await userService.getUserByEmail(firebaseUser.email);
        }

        if (existingUser) {
            return { user: existingUser, isNew: false };
        }

        const userData = {
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            name: firebaseUser.displayName,
            profilePic: firebaseUser.photoURL ? {
                photoUrl: firebaseUser.photoURL,
                public_id: null
            } : null,
            createdAt: new Date().toISOString(),
            provider,
            level: 'free',
            status: 'Inactive',
            invitations: 5,
            ref,
            weeklyInvitations: [],
            dailySwipes: 0,
            lastSwipeDate: null,
            acceptedInvitations: [],
            ...attribution
        };
        if (fbp) userData.fbp = fbp;
        if (fbc) userData.fbc = fbc;

        const createdUser = await userService.createUser(userData);
        return { user: createdUser, isNew: true };
    },

    // Mettre à jour le profil utilisateur
    updateProfile: async (userId, profileData) => {
        return api.put(`/user/${userId}/update`, profileData);
    },

    // Récupérer le profil utilisateur
    getProfile: async (userId) => {
        return api.get(`/user/${userId}`);
    },

    // Mettre à jour la photo de profil
    updateProfilePicture: async (userId, pictureData) => {
        return api.put(`/user/${userId}/picture`, pictureData);
    },

    // Supprimer une photo
    deletePhoto: async (userId, photoIndex) => {
        return api.delete(`/user/${userId}/photo/${photoIndex}`);
    },

    // Mettre à jour les photos
    updatePhotos: async (userId, photos) => {
        return api.put(`/user/${userId}/photos`, { photos });
    }
    // Vous pouvez ajouter d'autres méthodes liées à l'utilisateur ici
    // Par exemple :
    // getUserProfile: async (userId) => { ... },
    // updateUserProfile: async (userId, profileData) => { ... },
    // etc.
};
